<template>
  <div v-if="isActive" class="custom-bottom" :style="isIphone() ? 'z-index: 100; padding-bottom: 20px !important; height: 76px;' : 'z-index: 100'">
    <v-btn color="primary" @click="changeTab(2)" elevation="0" style="height: 56px; border-radius: 0px;">
      <v-icon class="mr-3" size="20px">mdi-plus-circle</v-icon> Novo checklist
    </v-btn>

    <v-bottom-navigation
      v-model="selectedTab"
      color="#48B38B"
      shift
      :style="isIphone() ? 'z-index: 100; padding-bottom: 20px; height: 56px;' : 'z-index: 100'"
    >
      <v-btn @click="changeTab(0)" style="width: 90px !important;">
        <span>Serviços</span>
        <v-icon>mdi-car-multiple</v-icon>
      </v-btn>
    </v-bottom-navigation>
  </div>
</template>
<script>
export default {
  name: 'StandardBottomNavigation',
  emits: ['update:tab'],
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      selectedTab: 0,
    };
  },
  methods: {
    isIphone() {
      if (this.getOS() === 'iOS') {
        return true;
      }
      return !!(this.$route.query.t && this.$route.query.t === 'ios');
    },
    getOS() {
      const uA = navigator.userAgent || navigator.vendor || window.opera;
      if ((/iPad|iPhone|iPod/.test(uA) && !window.MSStream) || (uA.includes('Mac') && 'ontouchend' in document)) return 'iOS';
      return null;
    },
    changeTab(tabIndex) {
      this.selectedTab = tabIndex;
      this.$emit('update:tab', tabIndex);
    },
  },
};
</script>
<style lang="scss">
.custom-bottom {
  background: white;
  display: flex;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  align-items: center;
  gap: 0px;
  box-shadow: none !important;

  .v-bottom-navigation {
    box-shadow: none !important;
    border-top: 2px solid #eee;
  }
}

.v-bottom-navigation {
  padding-bottom: 0 !important;
}
</style>
